import { render, staticRenderFns } from "./tracked.vue?vue&type=template&id=1b8b4548&"
import script from "./tracked.vue?vue&type=script&lang=js&"
export * from "./tracked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports